export default __webpack_public_path__ + "static/media/sports.85cbe9fb.png";